import toast from 'react-hot-toast';
import { AuthService } from '../services';
import { createFormData, getCookie } from '.';
import { store } from '../store';

export const fetchWrapper = {
  get: request('GET'),
  post: request('POST'),
  patch: request('PATCH'),
  put: request('PUT'),
  delete: request('DELETE')
};

function request(method) {
  return async (url, body) => {
    const requestOptions = { method, headers: authHeader() };
    if (body) {
      const session = store.getState()?.user;
      if (session) body._user_id = session?.id;

      if (body?.hasFile) {
        requestOptions.body = createFormData(body);

      } else {
        requestOptions.headers['Content-Type'] = 'application/json';
        requestOptions.body = JSON.stringify(body);
      }
    }
    return fetch(url, requestOptions).then(handleResponse);
  }
}

function authHeader() {
  const token = getCookie(process.env.REACT_APP_SESSION_NAME);
  return !!token
    ? { Authorization: `Bearer ${token}` }
    : {};
}

async function handleResponse(response) {
  const isJson = response.headers?.get('content-type')?.includes('application/json');
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    if ([401].includes(response.status)) {
      AuthService.removeSession();
    }

    const error = (data && (data?.message || data?.error)) || response.statusText;
    if (error) toast.error(error);
    return Promise.reject(error);
  }

  return data;
}

export const handleDownloadLocalFile = async (filePath) => {

  try {
    const response = await fetch(filePath);
    if (!response.ok) throw new Error('No se pudo descargar el archivo');
    return response.blob();
  } catch (error) {
    Promise.reject(error || 'Ocurrió un error inesperado al descargar el archivo');
  }
};